export default function FormsPage() {
  return (
	<div className="aqx-main-inner">
	  <div className="aqx-main-header">
		<h1>Forms</h1>
		<p>Forms placeholder. This page will manage Operator Forms.</p>
	  </div>
	</div>
  );
}